export const VehicleService = {
  None: 0,
  Dealer: 1,
  ThirdParty: 2,
  Both: 3,
}
